import $ from "jquery";

$(function initialize() {
  $(document).on('ready', function handleReady() {
    $('#composite_secondary_advisor_advisor_id_search').removeAttr('data-behavior-refresh-form');
  });
});
